.tooltip-wrapper-modal-content {
  color: #626469;
  font-size: 14px;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 30px 32px;
}